import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Style from './FJProgress.module.less'

function FJProgress(props) {
    let {percent = 0, innerClass = '', outerClass = ''} = props;
    let innerStyle;
    percent = percent < 0 ? 0 : percent;
    percent = percent > 1 ? 1 : percent;
    innerStyle = {width: percent * 100 + '%'};
    return (
        <div className={classNames(Style.progress__outer, outerClass)}>
            <div style={innerStyle} className={classNames(Style.progress__inner, innerClass)}/>
        </div>
    );
}

FJProgress.propTypes = {
    percent: PropTypes.number.isRequired,
    innerClass: PropTypes.string,
    outerClass: PropTypes.string,
};

export default FJProgress;